<template>
    <div>
        <div v-html="nuveiData"></div>
    </div>
</template>

<script>
    import { fxViewMixins } from "@/plugins/fxView";
    import { Const } from "@/plugins/fxView/provider/candle-history/lib/const.cls";
    import moment from "moment";
    import * as types from "@/types";
    import { mapActions } from "vuex";

    export default {
        name: "nuveiData",
        mixins: [fxViewMixins],
        data() {
            return {
                
            };
        },
        components: {
        },
        computed: {

        },
        watch: {
            shwStep(val) {
                $(".mainContent").animate({
                    scrollTop: 0
                }, "fast");
            }
        },
        methods: {

        },
        created() {

        },
    };
</script>


// WEBPACK FOOTER //
// src/components/fxView/deposit/nuvei.vue